import LayoutSidebar from "@/layouts/LayoutSidebar/LayoutSidebar.vue";

export default {
    components: LayoutSidebar,
    data() {
        return {
            layout: LayoutSidebar
        };
    },
    mounted() {
        if (typeof window.__PRERENDER_INJECTED !== "undefined") {
            this.$nextTick(() => {
                window.document.dispatchEvent(
                    new CustomEvent("spa-render-complete")
                );
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/pages/Examples/Home/ExamplesHome.js